import BulletRewards from './BulletRewards.vue'

export default BulletRewards
